import { Attribute } from '@strapi/strapi';

import CMSLink from '@tmh-website/components/shared/CMSLink';
import { type LinkField, isValidLinkField } from '@tmh-website/shared/cms';
import StyledTypo from '@tmh-website/styles/typo';
import { LocalePrefix } from '@tmh-website/shared/const';

import * as Styled from './FooterLinkGroup.styles';

interface FooterLinkGroupProps {
  linkGroup: Attribute.GetValues<'navigation.footer-link-group'>;
  isStandaloneMode: boolean;
  locale: LocalePrefix;
}

const FooterLinkGroup = ({ linkGroup, isStandaloneMode, locale }: FooterLinkGroupProps) => {
  const validChildren = linkGroup?.children && linkGroup?.children.filter(child => isValidLinkField(child.link));

  const headlineLinkField = linkGroup.link?.link;
  const headlineLabel = (linkGroup.link?.link as LinkField)?.label;

  return (
    <div>
      {isValidLinkField(headlineLinkField) ? (
        <CMSLink link={headlineLinkField} isStandaloneMode={isStandaloneMode} locale={locale}>
          <Styled.Headline $style='h6' as='a' $isLink>
            {headlineLabel}
          </Styled.Headline>
        </CMSLink>
      ) : (
        headlineLabel && (
          <StyledTypo.Typography $style='h6' as='span'>
            {headlineLabel}
          </StyledTypo.Typography>
        )
      )}
      {validChildren && (
        <Styled.Ul>
          {validChildren.map(
            child =>
              isValidLinkField(child.link) && (
                <li key={`${child.link.label}_${child.link.value}`}>
                  <CMSLink link={child.link} isStandaloneMode={isStandaloneMode} locale={locale}>
                    <Styled.SiteLink>{child.link.label}</Styled.SiteLink>
                  </CMSLink>
                </li>
              )
          )}
        </Styled.Ul>
      )}
    </div>
  );
};

export default FooterLinkGroup;
